import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PatcodeUrlRegisterationGuard implements CanActivate {
  constructor(private router : Router,private messageService : MessageService){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      //let id = +route.url[1].path;
    //  if(isNaN(id) || id < 0)
    //  {
    //   this.messageService.add({severity: 'error', summary: 'Error', detail:"Invalid Url", life: 2000});     
    //    this.router.navigate(['/login']);
    //    return false;
    //  }
      return true;    
  }
  
}
